import { useQuery } from '@tanstack/react-query';
import { IGetSubscriptionPlansResponse } from "../../utils/types";
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const getAllSubsCriptionPlans = async (params?: {
  limit?: number;
  page?: number;
  isActive?: number;
}) => {
  const res = await apiManager.get<IGetSubscriptionPlansResponse>(
    "/subscription-plan/get-all",
    params
  );
  return res;
};


export const useGetAllSubscriptionPlans = (params?: {
  limit?: number;
  page?: number;
  isActive?: number;
}) =>
  useQuery({
    queryKey: ["get_all_subscription_plans", params],
    queryFn: async (): Promise<IGetSubscriptionPlansResponse> => {
      const res = await apiClient.get(ENDPOINTS.SUBSCRIPTION_PLANS.GET_ALL, { params });
      return res.data;
    },
  });